import type { Distributor } from "./Distributor"

export interface AccountApplication {
  id: number
  bank_references: string | null
  billing_address: string | null
  billing_contact: string | null
  billing_contact_email: string | null
  billing_contact_phone: string | null
  buyer_contact_name: string | null
  created_at: string | null
  company_type: string | null
  delivery_address: string | null
  delivery_instructions: string | null
  distributor: Distributor
  email: string | null
  employer_identification_number: string | null
  fax: string | null
  full_corporate_name: string | null
  license_expiration_date: string | null
  liquor_license: string | null
  liquor_license_image_id: number | null
  liquor_license_image_name: string | null
  owner_name: string | null
  owner_email: string | null
  owner_home_address: string | null
  owner_phone: string | null
  owner_signature: string | null
  owner_verification_email: string | null
  pending_liquor_license: boolean
  phone: string | null
  resale_cert_number: string | null
  sales_rep_name: string | null
  status: AccountApplicationStatus
  trade_references: string | null
}

export enum AccountApplicationStatus {
  in_progress = "in_progress",
  submitted = "submitted",
  awaiting_signature = "awaiting_signature",
  verification_required = "verification_required",
  ignored = "ignored",
  accepted = "accepted"
}
